import * as types from "../actions/actionsTypes";

let initialState = {
  lastUpdated: 0,
  active: false,
  address: null,
  birthdate: "JJ/MM/AAAA",
  city: null,
  email: "",
  firstname: "",
  gender: "",
  id: null,
  // isForwork: true,
  lastname: "",
  phone: "",
  picture: "",
  points: 0,
  postal_code: null,
  store: null,
  shouldReset: false,
  shopIsOpen: true,
  deliveryAddress: null
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ACCOUNT_SET_DATAS:
      return {
        ...state,
        ...action.data,
        lastUpdated: Date.now(),
      };

    case types.ACCOUNT_SET_DELIVERY_ADDRESS:
      return {
        ...state,
        deliveryAddress: action.data,
      };

    case types.ACCOUNT_DEL_DATAS:
      return initialState;

    case "persist/REHYDRATE":
      if (action.payload && action.payload.account) {
        return {
          ...action.payload.account,
          lastUpdated: 0,
        };
      } else {
        return state;
      }

    default:
      return state;
  }
};

export default accountReducer;
